angular.module('app.ctrls').directive('uploadFile', function () {
    return {
        restrict: 'A',
        scope: {
            inputId: '@'
        },
        controller: function ($scope, $element) {
            $element.bind('click', function (e) {
                document.getElementById($scope.inputId).click();
            });
        }
    };
});
